export default __webpack_public_path__ + "static/media/ninos_vector_002.00ec2b34.png";